import { IPlayersGroupGames } from "@grassrootly/api/entities";
import withErrorCheck from "../CheckError";
import server from "../Server";

export interface PlayersPreviousGamesParams {
  date_to: string;
  pid: number;
}

export const GetPlayersPreviousGames = async ({
  date_to,
  pid,
}: PlayersPreviousGamesParams): Promise<IPlayersGroupGames[]> => {
  const previousGames = withErrorCheck(
    // @ts-ignore
    await server.rpc("players_previous_games", { date_to, pid })
  );

  if (!previousGames) return [];

  return previousGames;
};
